import React, { useState } from "react";
import BusinessSettings from "@/pages/BusinessSettings";
import ProductionSettings from "@/pages/ProductionSettings";
import { Building2, Sliders } from "lucide-react";

const TABS = [
  { key: "company", label: "Company & Invoicing", icon: Building2, component: BusinessSettings },
  { key: "admin", label: "Production Admin", icon: Sliders, component: ProductionSettings },
];

export default function Settings() {
  const [tab, setTab] = useState("company");
  const active = TABS.find((t) => t.key === tab) || TABS[0];
  const ActiveComponent = active.component;
  return (
    <div className="space-y-4">
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="border-b border-gray-200 flex items-center gap-1 px-3">
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = t.key === tab;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-4 py-3 text-sm font-semibold flex items-center gap-2 border-b-2 -mb-px transition-colors ${
                  isActive ? "border-[#9B1C1C] text-[#9B1C1C]" : "border-transparent text-gray-500 hover:text-gray-800"
                }`}
                data-testid={`settings-tab-${t.key}`}
              >
                <Icon className="h-4 w-4" />
                {t.label}
              </button>
            );
          })}
        </div>
      </div>
      <ActiveComponent />
    </div>
  );
}
